import React, { Suspense,useState,useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import { showRouterFallback } from "./fallback/Default";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import "./App.css";
import { ref, onValue } from "firebase/database";
import { db } from "./utilities/Firebase";
import Maintenance from "./page/Maintenance";
import SummaryCartReguler from "./page/sales_force_automation/SummaryCartReguler";
const ListApproval = React.lazy(() => import("./page/ApprovalBelanja/ListApproval"));
const ListHistoryApproval = React.lazy(() => import("./page/ApprovalBelanja/ListHistoryApproval"));
const ListGrosir = React.lazy(() => import("./page/ApprovalBelanja/ListGrosir"));
const ListPoint = React.lazy(() => import("./page/PointIncentive/ListPointNew"));
const ListPointMutasi = React.lazy(() => import("./page/PointIncentive/ListPointMutasi"));
const ListPointTransaksi = React.lazy(() => import("./page/PointIncentive/ListPointTransaksi"));

const ScanVisit = React.lazy(() => import('./page/ScanVisit'));
const Authentication = React.lazy(() => import('./page/Authentication'));
const Dashboard = React.lazy(() => import('./page/Dashboard'));
const UploadPhoto = React.lazy(() => import('./page/UploadPhoto'));
const StatusPhoto = React.lazy(() => import('./page/StatusPhoto'));
const StockReport = React.lazy(() => import('./page/StockReport'));
const SalesmanWholesaler = React.lazy(() => import('./page/SalesmanWholesaler'));
const RetailClassification = React.lazy(() => import('./page/RetailClassification'));
const SalesmanHomepage = React.lazy(() => import('./page/SalesmanHomepage'));
const SalesmanPresence = React.lazy(() => import('./page/SalesmanPresence'));
const SalesmanLeaveHomepage = React.lazy(() => import('./page/SalesmanLeaveHomepage'));
const SalesmanLeave = React.lazy(() => import('./page/SalesmanLeave'));
const SalesmanLocation = React.lazy(() => import('./page/SalesmanLocation'));
const SalesmanMission = React.lazy(() => import('./page/SalesmanMission'));
const MissionTypeA = React.lazy(() => import('./page/MissionTypeA'));
const ChangeDevice = React.lazy(() => import('./page/ChangeDevice'));
const AuditRetail = React.lazy(() => import('./page/AuditRetail'));
const ChangeDeviceReport = React.lazy(() => import('./page/ChangeDeviceReport'));
const RetailLocation = React.lazy(() => import('./page/RetailLocation'));
const UnblockLoan = React.lazy(() => import('./page/UnblockLoan'));
const AuditUnblockRetail = React.lazy(() => import('./page/AuditUnblockRetail'));
const LoanReport = React.lazy(() => import('./page/LoanReport'));
const RetailProfile = React.lazy(() => import('./page/RetailProfile'));
const RetailProfileOrder = React.lazy(() => import('./page/RetailProfileOrder'));
const ProposeCreditList = React.lazy(() => import('./page/ProposeCreditList'));
const ProposeCreditForm = React.lazy(() => import('./page/ProposeCreditForm'));
const ProposeCreditAudit = React.lazy(() => import('./page/ProposeCreditAudit'));
const ProposeCreditReport = React.lazy(() => import('./page/ProposeCreditReport'));
const SalesmanPoints = React.lazy(() => import('./page/SalesmanPoints'));
const VisitProgress = React.lazy(() => import('./page/VisitProgress'));
const PresenceCalendar = React.lazy(() => import('./page/PresenceCalendar'));
const RouteLocation = React.lazy(() => import('./page/RouteLocation'));
const SalesmanCancelVisit = React.lazy(() => import('./page/SalesmanCancelVisit'));
const RetailDisplay = React.lazy(() => import('./page/RetailDisplay'));
const RetailDocNOO = React.lazy(() => import('./page/RetailDocNOO'));
// Photo Retail
const RetailProfilePhoto = React.lazy(() => import("./page/RetailProfilePhoto"));
// Photo Retail
const RetailPencarianLk = React.lazy(() => import("./page/RetailPencarianLk"));
// Display
const RetailProfileDisplay = React.lazy(() => import("./page/RetailProfileDisplay"));
// Voucher
const RandomVoucher = React.lazy(() => import("./page_external/RandomVoucher"));
// Ctt Penawaran
const CatatanPenawaran = React.lazy(() => import("./page/CatatanPenawaran"));
const CatatanPenawaranDetail = React.lazy(() => import("./page/CatatanPenawaranDetail"));
const CatatanPenawaranList = React.lazy(() => import("./page/CatatanPenawaranList"));
// Peserta Display
const ParticipantDisplayAdd = React.lazy(() => import("./page/ParticipantDisplayAdd"));
const ParticipantDisplayList = React.lazy(() => import("./page/ParticipantDisplayList"));
const ParticipantDisplayDetail = React.lazy(() => import("./page/ParticipantDisplayDetail"));
const ParticipantDisplayApproval = React.lazy(() => import("./page/ParticipantDisplayApproval"));
const ParticipantDisplayDetailApproval = React.lazy(() => import("./page/ParticipantDisplayDetailApproval"));
const ParticipantDisplayHistoryIncentive = React.lazy(() => import("./page/ParticipantDisplayHistoryIncentive"));
// Sales Force Automation
const ListCustomer = React.lazy(() => import("./page/sales_force_automation/ListCustomer"));
const ListProduct = React.lazy(() => import("./page/sales_force_automation/ListProduct"));
const ListProductReguler = React.lazy(() => import("./page/sales_force_automation/ListProductReguler"));
const SummaryCart = React.lazy(() => import("./page/sales_force_automation/SummaryCart"));
const HistoryOrder = React.lazy(() => import("./page/sales_force_automation/HistoryOrder"));
const HistoryOrderReguler = React.lazy(() => import("./page/sales_force_automation/HistoryOrderReguler"));
const HistoryOrderDetail = React.lazy(() => import("./page/sales_force_automation/HistoryOrderDetail"));
const HistoryOrderDetailReguler = React.lazy(() => import("./page/sales_force_automation/HistoryOrderDetailReguler"));
const ListApprovalOrder = React.lazy(() => import("./page/sales_force_automation/ListApprovalOrder"));
const ListGrosirSFA = React.lazy(() => import("./page/sales_force_automation/ListGrosir"));
const SyncCustomer = React.lazy(() => import("./page/sales_force_automation/SyncCustomer"));
// Maps
const ChooseMap = React.lazy(() => import("./page/ChooseMap"))
// Merge NON CB dan NOO
const WithInstallApplication = React.lazy(() => import("./page/WithInstallApplication"));
const WithoutInstallApplication = React.lazy(() => import("./page/WithoutInstallApplication"));
const PointReward = React.lazy(() => import("./page/PointRewardIncentive/PointReward"));
const DetailActivity = React.lazy(() => import("./page/PointRewardIncentive/DetailActivity"));

function App() {
  const MaintenancePage = () => (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>🚧 We’re Under Maintenance 🚧</h1>
      <p>We'll be back soon. Stay tuned!</p>
    </div>
  );

  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    console.log("maintenance check")
    const maintenanceRef = ref(db, "/victory");
    // console.log(maintenanceRef)
    onValue(maintenanceRef, (snapshot) => {
      if (snapshot.exists()) {
        console.log("Snapshot Data:", snapshot);
        setMaintenance(snapshot.val());
      } else {
        console.log("No data found at /pos");
      }
    }, (error) => {
      console.error("Firebase read failed:", error);
    });
  }, []);

  return maintenance ? <Maintenance /> : (
    <Router>
      <Suspense fallback={showRouterFallback()}>
        <Switch>
          <Route exact path='/'><Authentication/></Route>
          <Route path='/scan_visit'><ScanVisit/></Route>
          <Route path='/dashboard'><Dashboard/></Route>
          <Route path='/upload_photo'><UploadPhoto/></Route>
          <Route path='/status_photo'><StatusPhoto/></Route>
          <Route path='/retail_class'><RetailClassification/></Route>
          <Route path='/stock'><StockReport/></Route>
          <Route path='/salesman_wholesaler'><SalesmanWholesaler/></Route>
          <Route path='/salesman_home'><SalesmanHomepage/></Route>
          <Route path='/salesman_presence'><SalesmanPresence/></Route>
          <Route path='/salesman_leave_home'><SalesmanLeaveHomepage/></Route>
          <Route path='/salesman_leave'><SalesmanLeave/></Route>
          <Route path='/salesman_location'><SalesmanLocation/></Route>
          <Route path='/salesman_mission'><SalesmanMission/></Route>
          <Route path='/mission_typea'><MissionTypeA/></Route>
          <Route path='/change_device'><ChangeDevice/></Route>
          <Route path='/audit_retail'><AuditRetail/></Route>
          <Route path='/change_device_report'><ChangeDeviceReport/></Route>
          <Route path='/retail_location'><RetailLocation/></Route>
          <Route path='/unblock_lk'><UnblockLoan/></Route>
          <Route path='/audit_ubretail'><AuditUnblockRetail/></Route>
          <Route path='/loan_report'><LoanReport/></Route>
          <Route path='/retail_profile'><RetailProfile/></Route>
          <Route path='/retail_profile_order'><RetailProfileOrder/></Route>
          <Route path='/propose_credit'><ProposeCreditList/></Route>
          <Route path='/propose_credit_form'><ProposeCreditForm/></Route>
          <Route path='/propose_credit_audit'><ProposeCreditAudit/></Route>
          <Route path='/propose_credit_report'><ProposeCreditReport/></Route>
          <Route path='/salesman_points'><SalesmanPoints/></Route>
          <Route path='/visit_progress'><VisitProgress/></Route>
          <Route path='/presence_calendar'><PresenceCalendar/></Route>
          <Route path='/route_location'><RouteLocation/></Route>
          <Route path='/cancel_visit'><SalesmanCancelVisit/></Route>
          <Route path='/retail_profile_photo'><RetailProfilePhoto/></Route>
          <Route path='/retail_pencairan_lk'><RetailPencarianLk/></Route>
          <Route path='/retail_profile_display'><RetailProfileDisplay/></Route>
          <Route path='/retail_display'><RetailDisplay/></Route>
          <Route path='/retail_noo'><RetailDocNOO/></Route>
          <Route path='/ctt_penawaran'><CatatanPenawaran/></Route>
          <Route path='/ctt_penawaran_detail'><CatatanPenawaranDetail/></Route>
          <Route path='/ctt_penawaran_list'><CatatanPenawaranList/></Route>
          <Route path='/peserta_display'><ParticipantDisplayAdd/></Route>
          <Route path='/list_peserta_display'><ParticipantDisplayList/></Route>
          <Route path='/detail_peserta_display'><ParticipantDisplayDetail/></Route>
          <Route path='/list_approval_peserta_display'><ParticipantDisplayApproval/></Route>
          <Route path='/detail_approval_peserta_display'><ParticipantDisplayDetailApproval/></Route>
          <Route path='/history_incentive'><ParticipantDisplayHistoryIncentive/></Route>
          <Route path='/list_approval'><ListApproval/></Route>
          <Route path='/list_history_approval'><ListHistoryApproval/></Route>
          <Route path='/list_grosir'><ListGrosir/></Route>
          <Route path='/list_customer'><ListCustomer/></Route>
          <Route path='/list_product'><ListProduct/></Route>
          <Route path='/list_product_reguler'><ListProductReguler/></Route>
          <Route path='/summary_cart'><SummaryCart/></Route>
          <Route path='/summary_cart_reguler'><SummaryCartReguler/></Route>
          <Route path='/history_order'><HistoryOrder/></Route>
          <Route path='/history_detail'><HistoryOrderDetail/></Route>
          <Route path='/history_order_reguler'><HistoryOrderReguler/></Route>
          <Route path='/history_detail_reguler'><HistoryOrderDetailReguler/></Route>
          <Route path='/list_approval_order'><ListApprovalOrder/></Route>
          <Route path='/list_point/:roles/:cust_name/:sales_id'><ListPoint/></Route>
          <Route path='/list_point_mutasi/:roles/:cust_name/:sales_id'><ListPointMutasi/></Route>
          <Route path='/list_point_transaksi/:roles/:cust_name/:sales_id'><ListPointTransaksi/></Route>
          <Route path='/list_grosir_sfa'><ListGrosirSFA/></Route>
          <Route path='/sync-customer'><SyncCustomer/></Route>
          <Route path='/with_application'><WithInstallApplication/></Route>
          <Route path='/without_application'><WithoutInstallApplication/></Route>
          <Route path='/point_reward'><PointReward/></Route>
          <Route path='/detail_activity'><DetailActivity/></Route>

          <Route path='/random_voucher'>
            <RandomVoucher />
          </Route>

          <Route path='/choose_map'>
            <ChooseMap />
          </Route>

          <Route>
            <Redirect to="/" />
          </Route>
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
